import React, { Component, PropTypes } from 'react';
import { IconButton } from 'material-ui';
import injectSheet from 'react-jss';
import MessageWrapper from '../../messaging/singleConv/message-wrapper';
import ActivityWithIcon from './activity-with-icon';
import { fileUrls } from '../../../api';
/*
  TODO: For contract actions use contracting / comments / comment.js
*/
const styles = {
  contractName: {
    whiteSpace: 'nowrap',
    marginTop: '10px',
    fontSize: '0.8em',
    marginRight: '4px',
  },
  subTitle: {
    whiteSpace: 'nowrap',
    fontWeight: 'bolder',
    marginBottom: '10px',
  },
  iconColor: {
    color: 'rgba(0, 0, 0, 0.54) !important',
  },
  button: {
    padding: '0 !important',
    height: '27px !important',
    marginTop: '10px !important',
    width: '37px !important',
  },
  textBody: {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  hideQuote: {
    display: 'none',
  },
  fileAttachment: {
    marginTop: '10px',
  },
  HTMLMessage: {
    display: 'block',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    lineHeight: '20px',
    width: '100%',
    overflowX: 'hidden',
    '& img': {
      display: 'none',
    },
    '& blockquote[type=\'cite\']': { // Outlook
      display: 'none',
    },
    '& div[class=\'\']': { // Outlook padding
      display: 'none',
    },
    '& .gmail_extra': { // Gmail
      display: 'none',
    },
    '& .gmail_quote': { // Gmail Quote
      display: 'none',
    },
    '& div[dir=\'ltr\']+br': { // Gmail padding
      display: 'none',
    },
    '& .gmail_signature': { // Gmail Signature
      display: 'none',
    },
  },
};

class historyAction extends Component {
  render() {
    const {
      attachments,
      bodyJson,
      contractId,
      participant,
      text,
      timestamp,
      classes,
      isSender,
      type,
    } = this.props;
    const contractName = ((bodyJson && bodyJson.contractName) ? bodyJson.contractName : '');
    const subTitle = (bodyJson && bodyJson.subject !== text) ? bodyJson.subject : '';
    const subSubject = (bodyJson && bodyJson.messageSubject !== text) ? bodyJson.messageSubject : '';
    // if (bodyJson && bodyJson.fromEmail && bodyJson.msgId) { // message from an email with a file

    // }
    let htmlText = null;
    if (bodyJson) {
      if (type === 'email' && bodyJson.html) {
        htmlText = bodyJson.html;
      } else if (!text && bodyJson.message) {
        htmlText = bodyJson.message;
      }
    }
    if (text.indexOf('<p') > -1) {
      htmlText = text;
    }
    return (
        <MessageWrapper
          avatarInfo={{
            name: participant.name,
            avatarUrl: participant.avatar || participant.profileImageUrl,
          }}
          timestamp={ (new Date(timestamp || new Date())).toString() }
          isSender={ isSender }
        >
          {(subTitle) ? <div className={classes.subTitle}>{subTitle}</div> : null }
          {(subSubject) ? <div className={classes.subTitle}>{subSubject}</div> : null }
          {(!htmlText) ? <div className={classes.textBody}>{ text }</div> : null}
          {(htmlText) ? <div
            className={`message-div ${classes.HTMLMessage}`}
            dangerouslySetInnerHTML={{ __html: htmlText }}
          /> : null}
          {contractId ? <ActivityWithIcon
/*            diff
            amendment
            editHistory={[]}*/
            lastestContractId={contractId}
/*            importedFields*/
            {...((bodyJson && bodyJson.statusChanged) ? { statusChanged: bodyJson.statusChanged } : {})}
          />
            : null }
            {(attachments || []).map((file, ix) => <ActivityWithIcon
              className={classes.fileAttachment}
              file={file}
              key={ix}
            />)}
          { contractId ?
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div className={classes.contractName}>{ contractName }</div>
              <IconButton
                iconClassName={`tc-icon-question_answer ${classes.iconColor}`}
                tooltip="Contract Activities"
                onTouchTap={() => this.props.routerPush(`/contracting/contract/${contractId}/activities`)}
                className={classes.button}
              />
              <IconButton
                iconClassName={`tc-icon-insert-drive-file ${classes.iconColor}`}
                tooltip="View Contract"
                onTouchTap={() => this.props.routerPush(`/contracting/contract/${contractId}/details`)}
                className={classes.button}
              />
            </div>
          : null }
        </MessageWrapper>
    );
  }
}
historyAction.defaultProps = {
  attachments: [],
  routerPush: location => { console.log(location); },
};
historyAction.propTypes = {
  attachments: PropTypes.array,
  bodyJson: PropTypes.object,
  classes: PropTypes.object,
  contractId: PropTypes.string,
  isSender: PropTypes.bool,
  participant: PropTypes.object,
  routerPush: PropTypes.func,
  text: PropTypes.string,
  timestamp: PropTypes.number,
  type: PropTypes.string,
};


export default injectSheet(styles)(historyAction);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/history-action.jsx